import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'

export default class ImageElement extends PureComponent {
  static propTypes = exact({
    element: PropTypes.object.isRequired,
    onLoad: PropTypes.func,
    preview: PropTypes.bool,
  })

  render() {
    const { element, preview, ...rest } = this.props
    const { width, height } = element

    const imageWidth = width / element.cropFractions.width,
      imageHeight = height / element.cropFractions.height

    const left = -element.cropFractions.left * imageWidth
    const top = -element.cropFractions.top * imageHeight
    const contentTransform = 'scale(var(--motion-content-scale, 1))'
    const contentTransformOrigin = `calc(var(--motion-content-origin-x, 50%) + ${left}px) calc(var(--motion-content-origin-y, 50%) + ${top}px)`
    const imageTransform = `scaleX(${element.isFlipped ? -1 : 1})`

    const imageStyle = {
      position: 'absolute',
      left: left,
      top: top,
      width: imageWidth,
      height: imageHeight,
      transform: imageTransform,
    }

    const motionWrapperStyle = {
      position: 'absolute',
      inset: 0,
      transform: contentTransform,
      transformOrigin: contentTransformOrigin,
    }

    const outline = element.backgroundColor
      ? '1px solid ' + element.backgroundColor
      : 'none'

    const previewImageSrc = () => {
      const url = new URL(element.url, window.location.origin)
      url.searchParams.set('variant', 'preview_thumbnail')
      return url.toString()
    }

    const imageSrc = preview ? previewImageSrc() : element.url

    return (
      <div
        className="ImageElement"
        data-element-id={element.id}
        style={{
          width,
          height,
          backgroundColor: element.backgroundColor,
          borderRadius: element.borderRadius,
          outline: outline,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div style={motionWrapperStyle}>
          <img src={imageSrc} style={imageStyle} draggable="false" {...rest} />
          {element.filterUrl && (
            <img src={element.filterUrl} style={imageStyle} draggable="false" />
          )}
        </div>
      </div>
    )
  }
}
